import { links, socials } from "./data";
import { FaWhatsapp } from "react-icons/fa";

import "./footer.css";

const Footer = () => {
  return (
    <footer>
      <a
        href="https://wa.me/919624882417"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaWhatsapp size={30} />
      </a>

      <div className="container footer__container">
        <ul className="nav__menu">
          {links.map((fLink) => (
            <li key={fLink.id}>
              <a href={fLink.link}>{fLink.title}</a>
            </li>
          ))}
        </ul>
        <div className="footer__socials">
          {socials.map((social) => (
            <a
              key={social.id}
              href={social.link}
              target={social.target}
              rel="noopener noreferrer"
            >
              {social.icon}
            </a>
          ))}
        </div>
      </div>
      <div className="footer__copyright">
        <small>2025 Jayesh Solanki &copy; All Rights Reserved</small>
      </div>
    </footer>
  );
};

export default Footer;
